import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { LANGS, S } from "@/i18n/strings";

const LangCtx = createContext(null);
const IDX = { ar: 0, fr: 1, en: 2, it: 3, de: 4 };

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rwiha_lang") || "ar");
  const meta = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    localStorage.setItem("rwiha_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
  }, [lang, meta.dir]);

  const t = useCallback(
    (key, vars) => {
      const row = S[key];
      if (!row) return key;
      let s = row[IDX[lang]] ?? row[2] ?? row[0];
      if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.replace(`{${k}}`, v)));
      return s;
    },
    [lang]
  );

  const tr = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.fr || obj.en || obj.ar || obj.it || obj.de || "";
    },
    [lang]
  );

  const fmt = useCallback(
    (n) => {
      const v = Number(n ?? 0).toLocaleString("fr-FR", { maximumFractionDigits: 2 });
      return lang === "ar" ? `${v} درهم` : `${v} DH`;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, tr, fmt, dir: meta.dir, rtl: meta.dir === "rtl" }), [lang, t, tr, fmt, meta.dir]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
